export const firstLetterUppercase: (str: string) => string = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const getFirstLetter = (str: string): string => str.charAt(0).toUpperCase()

export const removeExtension = (filename: string): string => filename.split('.').slice(0, -1).join('.')

export const truncateWithEllipsis = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text
  return `${text.slice(0, maxLength)}...`
}

export type FileType = 'image' | 'pdf' | 'word' | 'excel' | 'csv' | 'unknown'

export const getFileTypeFromName = (fileName: string): FileType => {
  if (!fileName) return 'unknown'

  const extension = fileName.toLowerCase().split('.').pop()

  switch (extension) {
    // Images
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
      return 'image'

    // Documents
    case 'pdf':
      return 'pdf'

    // Word
    case 'doc':
    case 'docx':
    case 'odt':
      return 'word'

    // Excel
    case 'xls':
    case 'xlsx':
    case 'xlsb':
    case 'xlsm':
    case 'ods':
      return 'excel'

    // CSV
    case 'csv':
      return 'csv'

    default:
      return 'unknown'
  }
}
